import { ViewportScroller } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonClass } from 'src/app/common';
import { ApiService } from 'src/app/services/api.service';
import { InterestMasterService } from 'src/app/services/interest-master.service';
import { NatureOfBusinessMasterService } from 'src/app/services/nature-of-business-master.service';
import { PaymentService } from 'src/app/services/payment.service';
import { environment } from 'src/environments/environment';
declare var Razorpay: any;

@Component({
  selector: 'app-member-data-edit',
  templateUrl: './member-data-edit.component.html',
  styleUrls: ['./member-data-edit.component.scss']
})
export class MemberDataEditComponent implements OnInit {
  private keyPressSubject = new Subject();
  // hwmMemberShipFormData: any = { waste_details: [], product_details: [] };
  hwmMemberShipFormData: any = { product_details: [{}], waste_details: [{ schedule_no: '' }] };
  hwmDocuments: any = {};
  productDetails: any = [];
  member_classification: any = {};
  selectedFile: File;
  turnoverData: any = {};
  categoryData: any = {};
  preferred1Checkbox: any = [];
  preferred2Checkbox: any = [];
  formResponse: any = [];
  isShow: boolean = true;
  adFee: any = [];
  trustFee: any = [];
  communication: any = ['Whatsapp', 'Email', 'Telephone'];
  today: any = new Date();
  invalidDates: Array<Date> = [];
  interest: any = [];
  interest1Checkbox: any = [];
  interest2Checkbox: any = [];
  natureofBusinessList: any = [];
  selectedState: string;
  selectedState1: string;
  selectedState2: string;
  selectedState3: string;
  turnoverRequired: boolean = true;
  certificateRequired: boolean = false;
  // @ViewChild('form') form: NgForm;
  local: any;
  state: any = [];
  HWMDetailsId: any = [];
  logoState: boolean = true;
  profile1State: boolean = true;
  profile2State: boolean = true;
  gstState: boolean = true;
  caState: boolean = true;
  ecState: boolean = true;
  cteState: boolean = true;
  ctoState: boolean = true;
  hwmState: boolean = true;
  underState: boolean = true;
  appState: boolean = true;
  hwmMemberList: any;
  logoPreviewState: boolean = true;
  modalStyle: string = 'none';
  HWMImgs_url: string = environment.HWMImgs_url;
  nominee1Image: string = environment.nominee1Image;
  nominee2Image: string = environment.nominee2Image;
  nominee1PreviewState: boolean = true;
  pre1: any = [];
  pre2: any = [];
  nominee2PreviewState: boolean = true;
  oldData: any;
  newData: any;
  otpState: boolean = false;
  otp: any;
  approveModalState: boolean = false;
  approveMemberModalState: boolean = false;
  form: NgForm;
  orderId: any;
  amount: number;
  successState: boolean = false;
  gstDocState: boolean = true;
  caDocState: any = true;
  formData: FormData;
  loggedInUserEmail: any;
  logoName: string;
  oldNominee1State: boolean = true;
  oldNominee2State: boolean = true;
  profile1Name: string;
  profile2Name: string;
  oldAppState: boolean = true;
  oldUndertakingState: boolean = true;
  oldec4State: boolean = true;
  oldec3State: boolean = true;
  oldec2State: boolean = true;
  oldecState: boolean = true;
  cteDocBaseURL: string = environment.cteDocBaseURL;
  ecCertificateBaseURL: string = environment.ecDocBaseURL;
  ctoDocBaseURL: string = environment.ctoDocBaseURL;
  hwmDocBaseURL: string = environment.hwmDocBaseURL;
  appDocBaseURL: string = environment.appDocBaseURL;
  utDocBaseURL: string = environment.utDocBaseURL;
  supporting_doc_url:string=environment.supporting_doc_url
  applicationChanged: boolean = false;
  underTakingChanged: boolean = false;
  requiredAnyOneDoc: boolean = true;
  supporting_doc:boolean=false;
  ec_document: any;
  cte_document: any;
  cto_document: any;
  hwm_document: any;
  successMessage: any;
  paymentStatus: boolean = false;
  paymentResponse: { formState: boolean; merchantRequest: any };
  slug: any;
  memberId: any;
  gatewayResponse: any;
  roDetails: any = [];
  showCommencementDate: boolean = false;
  selectedState4: string;
  selectedDistrict1: any;
  selectedDistrict2: any;
  selectedOffice: any;
  scheduleList: any[];
  wasteList: any[];
  showCodeInput: boolean = false;
  showProcessInput: boolean = false;
  scheduleArray: any = [];
  showAccessAlert: boolean = false;
  localStorage: any;
  nominee: any;
  memberStatus: any;
  isRevised:boolean = false;
  isRenewed:boolean = false;
  scheduleNoArray: any = [
    { schedule_no: 1 },
    { schedule_no: 2 },
    { schedule_no: 3 },
    { schedule_no: 4 },
  ]
  userId: any;
  showWasteTypeInput: boolean = false;
  wasteTypeOptions: { label: string, value: string }[] = [
    { label: 'Metric Ton Per Annum (MTPA)', value: 'MTPA' },
    { label: 'Litres per Annum (LPA)', value: 'LPA' },
    { label: 'Numbers (Nos)', value: 'Nos' }
];
  constructor(
    private apiservice: ApiService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private paymentservice: PaymentService,
    private interestMasterService: InterestMasterService,
    private nobmaster: NatureOfBusinessMasterService,
    private commonFunction: CommonClass,
    private scroller: ViewportScroller,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private ActivatedRoute: ActivatedRoute,
    public route: Router
  ) { }
  ngOnInit(): void {
    this.localStorage = this.commonFunction.getLocalStorage();
    this.spinner.show();
    this.getScheduleData();
    this.getAreaofInterest();
    this.getNatureofBusiness();
    if (this.localStorage.role == 'HWM Owner' || this.localStorage.role == 'HWM Contact Person') {
      this.getPendingMembership();
    }
    this.slug = this.ActivatedRoute.snapshot.params;
    console.log(this.slug);

    if (this.slug.id && this.slug.order_id && this.slug.status) {
      let statusDetail =
        { status: this.slug?.status == 'Success' ? 'In Progress' : 'Pending', }
      // this.paymentservice
      //   .hwmMemberDataPaymentStatusUpdate(this.slug.id, statusDetail)
      //   .subscribe((res: any) => {
      //     if (res.code == 200) {
      //       this.successMessage = {
      //         form: 'hwm-edit',
      //         message: 'Form Submitted Successfully',
      //       };
      //       this.successState = true;
      //     }
      //   });
    } else {
      this.apiservice.getTurnoverData().subscribe((res: any) => {
        this.turnoverData = res;
      });
      this.apiservice.getMemberClassfication().subscribe((res: any) => {
        this.member_classification = res;
      });
      this.apiservice.getMemberCategory().subscribe((res: any) => {
        this.categoryData = res;
      });
      this.getStates();
      this.invalidDates.push(this.today);
      this.getRODetails();
      // this.spinner.show();
      // if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
        this.getMemberById();
      // }
      this.getHwmMemberList();
      // setTimeout(() => {
      // }, 2000);

      this.loggedInUserEmail = this.commonFunction.getLocalStorage().useremail;
    }
    this.keyPressSubject.pipe(debounceTime(500)).subscribe(() => {
      this.onSendOtp();
    });
  }
  // addProductDetailRow() {
  //   this.hwmMemberShipFormData?.waste_details.push({});
  // }
  //to add one row to product detail
  product_details_boolean: boolean = false;
  addProductDetailRow(string?: any) {
    if (string == 'product') {
      // let validation = this.getValidation();

      // console.log(validation);

      if (this.product_details_boolean == false) {
        this.hwmMemberShipFormData.product_details.push({
          product_description: '',
          product_quantity: '',
        });
      } else {
        this.messageService.add({
          severity: 'error',
          // summary: 'Some details are not filled!',
          detail: 'Please Fill All the Details!',
        });
      }
    }

    else {
      this.hwmMemberShipFormData.waste_details.push({ schedule_no: '' });
    }
  }

  addDocument() {
    this.hwmMemberShipFormData.supprting_doc.push({});
  }

  downLoadPdf(url: string) {
    console.log(url);
    
    console.log('====================================');
    // console.log(url);
    // console.log('====================================');
    if (url.endsWith('.pdf')) {
      let value = url;
      console.log(value);
      var anchor = document.createElement('a');
      anchor.download = value;
      anchor.href = value;
      anchor.target = '_blank';
      anchor.click();
    }
  }
  hwmMemberData: any = [];
  getMemberById() {
    
    const slugId = this.slug.slug;
    this.apiservice.getMemberDataByIdForEdit(slugId).then((res: any) => {
      this.hwmMemberData = res?.data?.member_data_json;
      // Clean up and parse fields as needed
      const d = this.hwmMemberData;
      console.log(d, "cllass");
     console.log( JSON.parse(d.waste_details));
     
      // Parse JSON fields if they are strings
      let waste_details = Array.isArray(d.waste_details) ? d.waste_details : (typeof d.waste_details === 'string' && d.waste_details ? JSON.parse(d.waste_details) : []);
      let product_details = Array.isArray(d.product_details) ? d.product_details : (typeof d.product_details === 'string' && d.product_details ? JSON.parse(d.product_details) : []);
      let ec_consents_status = Array.isArray(d.ec_consents_status) ? d.ec_consents_status : (typeof d.ec_consents_status === 'string' && d.ec_consents_status ? JSON.parse(d.ec_consents_status) : []);
      let supporting_doc = d.supporting_doc || d.supprting_doc;
      if (typeof supporting_doc === 'string' && supporting_doc.startsWith('{')) {
        supporting_doc = JSON.parse(supporting_doc);
      }
      // Handle preferred communication fields
      let preferred1 = d.preferred_communication1 || [];
      let preferred2 = d.preferred_communication2 || [];
      preferred1 = Array.isArray(preferred1) ? preferred1.filter(x => x && x !== 'undefined' && x !== 'null') : [];
      preferred2 = Array.isArray(preferred2) ? preferred2.filter(x => x && x !== 'undefined' && x !== 'null') : [];

      // --- Dropdown/Select Mapping ---
      // Nature of Business (optionValue="id")
      let mappedNatureOfBusiness = '';
      if (d.nature_of_business) {
        if (typeof d.nature_of_business === 'string' || typeof d.nature_of_business === 'number') {
          // Try to find by id or name
          mappedNatureOfBusiness = this.natureofBusinessList.find((n: any) => n.id == d.nature_of_business || n.name === d.nature_of_business)?.id || '';
        }
      }
      // Turnover (optionValue="id")
      let mappedTurnoverId = '';
      if (d.turnover_id) {
        mappedTurnoverId = this.turnoverData?.data?.find((t: any) => t.id == d.turnover_id)?.id || '';
      }
      // Area of Interest 1 (array of objects)
      let mappedAreaOfInterest1: any[] = [];
      if (d.nominee1_aoi) {
        if (typeof d.nominee1_aoi === 'string') {
          mappedAreaOfInterest1 = d.nominee1_aoi.split(',').map((id: any) => this.interest.find((i: any) => i.id == id)).filter(Boolean);
        } else if (Array.isArray(d.nominee1_aoi)) {
          mappedAreaOfInterest1 = d.nominee1_aoi.map((id: any) => this.interest.find((i: any) => i.id == id)).filter(Boolean);
        }
      }
      // Area of Interest 2 (array of objects)
      let mappedAreaOfInterest2: any[] = [];
      if (d.nominee2_aoi) {
        if (typeof d.nominee2_aoi === 'string') {
          mappedAreaOfInterest2 = d.nominee2_aoi.split(',').map((id: any) => this.interest.find((i: any) => i.id == id)).filter(Boolean);
        } else if (Array.isArray(d.nominee2_aoi)) {
          mappedAreaOfInterest2 = d.nominee2_aoi.map((id: any) => this.interest.find((i: any) => i.id == id)).filter(Boolean);
        }
      }
      // --- End Dropdown/Select Mapping ---

      // Map to form data
      this.hwmMemberShipFormData = {
        company_name: d.company_name || '',
        gst_number: d.gst_number || '',
        cin_number: (d.cin_number === 'null' ? '' : d.cin_number) || '',
        factory_address: d.factory_address || '',
        factory_city: d.factory_city || '',
        factory_pin_code: d.factory_pin_code || '',
        unit: (d.unit === 'null' ? '' : d.unit) || '',
        registered_address: d.registered_address || '',
        registered_city: d.registered_city || '',
        registered_pin_code: d.registered_pin_code || '',
        registration_number: d.registration_number || '',
        capital_investment: d.capital_investment || '',
        website: (d.website === 'null' ? '' : d.website) || '',
        email: d.email || '',
        nature_of_business: mappedNatureOfBusiness,
        name1: d.name1 || '',
        designation1: (d.designation1 === 'null' ? '' : d.designation1) || '',
        pan_number1: (d.pan_number1 === 'null' ? '' : d.pan_number1) || '',
        email1: d.email1 || '',
        office_phone1: (d.office_phone1 === 'null' ? '' : d.office_phone1) || '',
        mobile_no1: d.mobile_no1 || '',
        department1: (d.department1 === 'null' ? '' : d.department1) || '',
        nominee1_address: d.nominee1_address || '',
        nominee1_city: d.nominee1_city || '',
        nominee1_pin_code: d.nominee1_pin_code || '',
        biodata1: (d.biodata1 === 'null' ? '' : d.biodata1) || '',
        name2: d.name2 || '',
        designation2: (d.designation2 === 'null' ? '' : d.designation2) || '',
        pan_number2: (d.pan_number2 === 'null' ? '' : d.pan_number2) || '',
        email2: d.email2 || '',
        mobile_no2: d.mobile_no2 || '',
        department2: (d.department2 === 'null' ? '' : d.department2) || '',
        nominee2_address: d.nominee2_address || '',
        investment: d.investment || '',
        hw_disposal_expected_date: d.hw_disposal_expected_date ? new Date(d.hw_disposal_expected_date) : null,
        production_commencement_date: d.production_commencement_date ? new Date(d.production_commencement_date) : null,
        incineration_facility_required: d.incineration_facility_required || '',
        productionStarted: d.productionStarted || '',
        turnover_id: mappedTurnoverId,
        is_ec_applied: d.is_ec_applied || '',
        is_cte_applied: d.is_cte_applied || '',
        is_cto_applied: d.is_cto_applied || '',
        is_hwm_auth_applied: d.is_hwm_auth_applied || '',
        is_ec_obtained: d.is_ec_obtained || '',
        is_cte_obtained: d.is_cte_obtained || '',
        is_cto_obtained: d.is_cto_obtained || '',
        is_hwm_auth_obtained: d.is_hwm_auth_obtained || '',
        ec_hold_reason: d.ec_hold_reason || '',
        cte_hold_reason: d.cte_hold_reason || '',
        cto_hold_reason: d.cto_hold_reason || '',
        hwm_hold_reason: d.hwm_hold_reason || '',
        remarks: (d.remarks === 'null' ? '' : d.remarks) || '',
        supporting_doc: supporting_doc || {},
        past_letter_date: d.past_letter_date ? new Date(d.past_letter_date) : null,
        ec_consents_status: ec_consents_status,
        waste_details: waste_details,
        product_details: product_details,
        nominee1_state: d.nominee1_state || '',
        registered_state: d.registered_state || '',
        registered_district: d.registered_district || '',
        factory_district: d.factory_district || '',
        regional_office: d.regional_office || '',
        factory_state: d.factory_state || '',
        logo: (d.logo === 'null' ? '' : d.logo) || '',
        ca_certificate: (d.ca_certificate === 'null' ? '' : d.ca_certificate) || '',
        preferred_communication1: preferred1,
        preferred_communication2: preferred2,
        area_of_interest1: mappedAreaOfInterest1,
        area_of_interest2: mappedAreaOfInterest2,
        nominee1_aoi: d.nominee1_aoi || '',
        nominee2_aoi: d.nominee2_aoi || '',
        membership_type: d.membership_type || '',
        payment_id: d.payment_id || '',
        order_id: d.order_id || '',
        undertaking: Array.isArray(d.undertaking) ? d.undertaking : [],
        application: Array.isArray(d.application) ? d.application : [],
        gst_certificate: Array.isArray(d.gst_certificate) ? d.gst_certificate : [],
        otp: d.otp || '',
        changed_in: d.changed_in || '',
      };
      // Set CA certificate check
      this.caCertificateCheck = !!(this.hwmMemberShipFormData.ca_certificate && this.hwmMemberShipFormData.ca_certificate !== '' && this.hwmMemberShipFormData.ca_certificate !== null && this.hwmMemberShipFormData.ca_certificate !== undefined);

      // Map state/district string values to dropdown objects
      this.selectedState3 = this.state.find((s: any) => s.name === d.factory_state) || null;
      this.selectedState4 = this.state.find((s: any) => s.name === d.registered_state) || null;
      this.selectedDistrict1 = this.roDetails.find((r: any) => r.regional_office_name === d.registered_district) || null;
      this.selectedDistrict2 = this.roDetails.find((r: any) => r.regional_office_name === d.factory_district) || null;
      this.selectedOffice = this.roDetails.find((r: any) => r.regional_office_name === d.regional_office) || null;
      this.selectedState1 = this.state.find((s: any) => s.name === d.nominee1_state) || null;

      // Prefill dropdown options for each waste_details row
      if (Array.isArray(this.hwmMemberShipFormData.waste_details)) {
        this.hwmMemberShipFormData.waste_details.forEach((item, index) => {
          this.getScheduleList({ value: item.schedule_no }, 'schNo', index, true);
          if (item.schedule_no === 1 || item.schedule_no === '1') {
            this.getScheduleList({ value: item.waste_process_no }, 'process-no', index, true);
              this.getScheduleList({ value: item.waste_sub_process_no }, 'code', index, true);
          }
        });
      }

      this.spinner.hide();
    });
  }
 

  // hwm member list
  RegisteraddressList: any = [];
  FactoryaddressList: any = [];
  async getHwmMemberList() {
    // Use the new API for fetching member data for edit
    if (!this.slug?.id) return;
    try {
      const res = await this.apiservice.getMemberDataByIdForEdit(this.slug.id);
      const data = res?.data;
      if (!data) return;
      const hwmMemberData = data.member_data_json || {};

      // Parse JSON string fields if needed
      let waste_details = [];
      if (typeof hwmMemberData.waste_details === 'string') {
        try { waste_details = JSON.parse(hwmMemberData.waste_details); } catch { waste_details = []; }
      } else if (Array.isArray(hwmMemberData.waste_details)) {
        waste_details = hwmMemberData.waste_details;
      }
      let product_details = [];
      if (typeof hwmMemberData.product_details === 'string') {
        try { product_details = JSON.parse(hwmMemberData.product_details); } catch { product_details = []; }
      } else if (Array.isArray(hwmMemberData.product_details)) {
        product_details = hwmMemberData.product_details;
      }
      let ec_consents_status = [];
      if (typeof hwmMemberData.ec_consents_status === 'string') {
        try { ec_consents_status = JSON.parse(hwmMemberData.ec_consents_status); } catch { ec_consents_status = []; }
      } else if (Array.isArray(hwmMemberData.ec_consents_status)) {
        ec_consents_status = hwmMemberData.ec_consents_status;
      }
      // Parse area of interest fields (comma separated string or array)
      let area_of_interest1 = [];
      if (typeof hwmMemberData.nominee1_aoi === 'string') {
        area_of_interest1 = hwmMemberData.nominee1_aoi.split(',').map(x => x.trim()).filter(x => x);
      } else if (Array.isArray(hwmMemberData.nominee1_aoi)) {
        area_of_interest1 = hwmMemberData.nominee1_aoi;
      }
      let area_of_interest2 = [];
      if (typeof hwmMemberData.nominee2_aoi === 'string') {
        area_of_interest2 = hwmMemberData.nominee2_aoi.split(',').map(x => x.trim()).filter(x => x);
      } else if (Array.isArray(hwmMemberData.nominee2_aoi)) {
        area_of_interest2 = hwmMemberData.nominee2_aoi;
      }
      // Preferred communication fields
      let preferred_communication1 = hwmMemberData.preferred_communication1 || [];
      let preferred_communication2 = hwmMemberData.preferred_communication2 || [];
      // Supporting docs (from root array)
      let supporting_doc = [];
      if (Array.isArray(data.supporting_docs)) {
        supporting_doc = data.supporting_docs.map(doc => ({
          document_for: doc.document_for,
          document: doc.document
        }));
      }
      // Fallback to hwmMemberData.supporting_doc if needed
      if (!supporting_doc.length && hwmMemberData.supporting_doc) {
        if (typeof hwmMemberData.supporting_doc === 'string') {
          try { supporting_doc = JSON.parse(hwmMemberData.supporting_doc); } catch { supporting_doc = []; }
        } else if (Array.isArray(hwmMemberData.supporting_doc)) {
          supporting_doc = hwmMemberData.supporting_doc;
        }
      }
      // Assign to form model
      this.hwmMemberShipFormData = {
        ...hwmMemberData,
        waste_details,
        product_details,
        ec_consents_status,
        area_of_interest1,
        area_of_interest2,
        preferred_communication1,
        preferred_communication2,
        supprting_doc: supporting_doc,
      };
      // Set state/district/office selections for dropdowns
      this.selectedState3 = hwmMemberData.factory_state || null;
      this.selectedState4 = hwmMemberData.registered_state || null;
      this.selectedDistrict1 = hwmMemberData.registered_district || null;
      this.selectedDistrict2 = hwmMemberData.factory_district || null;
      this.selectedOffice = hwmMemberData.regional_office || null;
      // Set nominee state
      this.selectedState1 = hwmMemberData.nominee1_state || null;
      // Set checkboxes for preferred communication
      this.preferred1Checkbox = Array.isArray(preferred_communication1) ? preferred_communication1 : [];
      this.preferred2Checkbox = Array.isArray(preferred_communication2) ? preferred_communication2 : [];
      // Set memberId, status, etc.
      this.memberId = data.member_id;
      this.memberStatus = data.status;
      // Hide spinner if used
      if (this.spinner) this.spinner.hide();
    } catch (err) {
      console.error('Error fetching member data for edit:', err);
      if (this.spinner) this.spinner.hide();
    }
  }

  setWasteDetails(waste_details) {
    console.log(waste_details, this.wasteList);
    waste_details.forEach((res: any, index: any) => {
      this.scheduleList = [];
      if (res.schedule_no == 1) {
        this.scheduleListProcess[index] = { showCodeInput: false, showProcessInput: false };
        this.wasteList?.forEach((list: any) => {
          if (res.waste_process_no == list?.process_no && list?.parent_id) {
            this.scheduleList.push(list);
          }
        })
        console.log(this.scheduleList)
      }

      else {
        this.scheduleListProcess[index] = { showCodeInput: true, showProcessInput: true };
      }
      this.newScheduleList[index] = { index: index, value: this.scheduleList };
      console.log(this.newScheduleList);


    })

    console.log(this.scheduleListProcess);
  }

  otpForm = this.fb.group({
    email: [null, [Validators.required]],
    otp: [null],
  });

  get o() {
    return this.otpForm.controls;
  }
  onClose() {
    this.otpState = false;
  }
  appliedByForm = this.fb.group({
    userId: [null, [Validators.required]],
  });
  get s() {
    return this.appliedByForm.controls;
  }
  submitData() {
    this.formData = new FormData();

    // Format date fields as needed
    const formatDate = (date: any) => date ? moment(date).format('YYYY/MM/DD') : '';

    // Prepare data for submission
    const data = this.hwmMemberShipFormData;

    // Append all simple fields directly
    const simpleFields = [
      'company_name', 'gst_number', 'cin_number', 'factory_address', 'factory_city', 'factory_pin_code', 'unit',
      'registered_address', 'registered_city', 'registered_pin_code', 'registration_number', 'capital_investment',
      'website', 'email', 'nature_of_business', 'name1', 'designation1', 'pan_number1', 'email1', 'office_phone1',
      'mobile_no1', 'department1', 'nominee1_address', 'nominee1_city', 'nominee1_pin_code', 'biodata1', 'name2',
      'designation2', 'pan_number2', 'email2', 'mobile_no2', 'department2', 'nominee2_address', 'investment',
      'incineration_facility_required', 'productionStarted', 'turnover_id', 'is_ec_applied', 'is_cte_applied',
      'is_cto_applied', 'is_hwm_auth_applied', 'is_ec_obtained', 'is_cte_obtained', 'is_cto_obtained',
      'is_hwm_auth_obtained', 'ec_hold_reason', 'cte_hold_reason', 'cto_hold_reason', 'hwm_hold_reason', 'remarks',
      'nominee1_state', 'registered_state', 'registered_district', 'factory_district', 'regional_office', 'factory_state',
      'logo', 'ca_certificate', 'nominee1_aoi', 'nominee2_aoi', 'membership_type', 'payment_id', 'order_id', 'otp', 'changed_in'
    ];

  simpleFields.forEach(key => {
  this.formData.append(key, `${data[key]}`);
});

    // Format and append date fields
    this.formData.set('hw_disposal_expected_date', formatDate(data.hw_disposal_expected_date));
    this.formData.set('production_commencement_date', formatDate(data.production_commencement_date));
    this.formData.set('past_letter_date', formatDate(data.past_letter_date));

    // Handle JSON fields
    this.formData.set('waste_details', JSON.stringify(data.waste_details ?? []));
    this.formData.set('product_details', JSON.stringify(data.product_details ?? []));
    this.formData.set('ec_consents_status', JSON.stringify(data.ec_consents_status ?? []));
    this.formData.set('undertaking', JSON.stringify(data.undertaking ?? []));
    this.formData.set('application', JSON.stringify(data.application ?? []));
    this.formData.set('gst_certificate', JSON.stringify(data.gst_certificate ?? []));
    this.formData.set('supporting_doc', JSON.stringify(data.supporting_doc ?? {}));

    // Handle preferred communication arrays
    (data.preferred_communication1 || []).forEach((item: string) => {
      this.formData.append('preferred_communication1[]', item);
    });
    (data.preferred_communication2 || []).forEach((item: string) => {
      this.formData.append('preferred_communication2[]', item);
    });

    // Handle file/document fields if needed (example, adjust as per your logic)
    if (this.hwmDocuments?.logo) this.formData.append('logo', this.hwmDocuments.logo);
    if (this.hwmDocuments?.profile1) this.formData.append('profile1', this.hwmDocuments.profile1);
    if (this.hwmDocuments?.profile2) this.formData.append('profile2', this.hwmDocuments.profile2);
    if (this.hwmDocuments?.gst_certificate) this.formData.append('gst_certificate', this.hwmDocuments.gst_certificate);
    if (this.hwmDocuments?.ca_certificate) this.formData.append('ca_certificate', this.hwmDocuments.ca_certificate);
 this.formData.append('member_id', this.slug.slug ?? null);
    // Submit the form
   this.apiservice.edithwmrevisionbyid(this.slug.slug,this.formData).subscribe(
  (res: any) => {
    this.messageService.add({
      severity: 'success',
      detail: res?.message,
    });
    this.successMessage = {
      form: 'hwm-edit',
      message: 'Form Submitted Successfully',
    };
    this.successState = true;
  },
  (err) => {
    this.messageService.add({
      severity: 'error',
      detail: 'Something went wrong',
    });
  }
  
);
  setTimeout(() => {
          this.route.navigateByUrl('/user-panel/member-data-update');
       1500});
  }
  change(string: any) {
    if (string == 'state') {
      this.hwmMemberShipFormData.state = this.selectedState;
    } else if (string == 'nominee1_state') {
      this.hwmMemberShipFormData.nominee1_state = this.selectedState1;
    } else if (string == 'nominee2_state') {
      this.hwmMemberShipFormData.nominee2_state = this.selectedState2;
    } else if (string == 'factory_state') {
      this.hwmMemberShipFormData.factory_state = this.selectedState3;
    } else if (string == 'registered_state') {
      this.hwmMemberShipFormData.registered_state = this.selectedState4;
    } else if (string == 'registered_district') {
      this.hwmMemberShipFormData.registered_district = this.selectedDistrict1;
    } else if (string == 'factory_district') {
      this.hwmMemberShipFormData.factory_district = this.selectedDistrict2;
    } else if (string == 'regional_office') {
      this.hwmMemberShipFormData.regional_office = this.selectedOffice;
    }

  }
  // state dropdown
  getStates() {
    this.apiservice
      .getStateWithJson('assets/state.json')
      .subscribe((res: any) => {
        this.state = res.Data;
        // // console.log(this.state);
      });
  }
  // on change for multiple preferred communication checkbox selection
  // onChange(communication?: any, data?: any, string?: any) {
  //   if (communication) {
  //     string == 'pre1'
  //       ? this.preferred1Checkbox.push(data)
  //       : this.preferred2Checkbox.push(data);
  //   } else {
  //     let index: any;
  //     string == 'pre1'
  //       ? (index = this.preferred1Checkbox.find((x) => x == data))
  //       : (index = this.preferred2Checkbox.find((x) => x == data));
  //     if (index) {
  //       string == 'pre1'
  //         ? this.preferred1Checkbox.splice(
  //           this.preferred1Checkbox.indexOf(index),
  //           1
  //         )
  //         : this.preferred2Checkbox.splice(
  //           this.preferred1Checkbox.indexOf(index),
  //           1
  //         );
  //     }
  //   }
  //   // console.log(this.preferred1Checkbox);
  //   // console.log(this.preferred2Checkbox);
  // }
  onChange(communication?: any, data?: any, string?: string) {
    if (communication) {
      if (data !== null) {
        if (string === 'pre1') {
          this.preferred1Checkbox.push(data);
        } else if (string === 'pre2') {
          this.preferred2Checkbox.push(data);
        }
      }
    } else {
      let index: number;
      if (string === 'pre1') {
        index = this.preferred1Checkbox.findIndex(x => x === data);
        if (index !== -1) {
          this.preferred1Checkbox.splice(index, 1);
        }
      } else if (string === 'pre2') {
        index = this.preferred2Checkbox.findIndex(x => x === data);
        if (index !== -1) {
          this.preferred2Checkbox.splice(index, 1);
        }
      }
    }
  }

  // on otp resend

  onOtpResend() {
    let emailObject = {
      email: this.otpForm.value.email,
    };
    this.apiservice.generateOTP(emailObject).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        detail: res.message,
      });
    });
  }
  // onSendOtp(event: KeyboardEvent) {
  //   // Prevent default form submission behavior
  //   event.preventDefault();

  //   if (this.localStorage.role == 'HWM Owner' || this.localStorage.role == 'HWM Contact Person') {
  //     if (this.otpForm.valid) {
  //       this.otp = this.otpForm.value.otp;
  //       this.spinner.show();
  //       this.apiservice
  //         .OTPVerification(this.otpForm.value)
  //         .subscribe((res: any) => {
  //           console.log(res);
  //           this.spinner.hide();
  //           this.messageService.add({
  //             severity: 'success',
  //             detail: res.message,
  //           });
  //           this.submitData();
  //         });
  //     }
  //   } else if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
  //     if (this.appliedByForm.valid) {
  //       this.userId = this.appliedByForm.value.userId;
  //       this.submitData();
  //     }
  //   }
  // }
onSendOtp() {
  const isTesting = true; // ⚠️ Set to false or remove for production

  if (this.localStorage.role == 'HWM Owner' || this.localStorage.role == 'HWM Contact Person') {
    if (this.otpForm.valid || isTesting) {
      if (!isTesting) {
        this.otp = this.otpForm.value.otp;
        this.spinner.show();
        this.apiservice.OTPVerification(this.otpForm.value).subscribe((res: any) => {
          console.log(res);
          this.spinner.hide();
          this.messageService.add({
            severity: 'success',
            detail: res.message,
          });
          this.submitData();
        });
      } else {
        // Directly call submitData() in test mode
        this.submitData();
      }
    }
  } else if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
    if (this.appliedByForm.valid) {
      this.userId = this.appliedByForm.value.userId;
      this.submitData();
    }
  }
}

  handleKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default behavior of Enter key
      this.keyPressSubject.next();
    }
  }

  //to register HWM membership candidate
  // Register(form: NgForm) {
  //   // this.HWMDetailsId = data.hwm_details_id
  //   // // console.log(this.HWMDetailsId)
  //   // for(let i = 0; i < )

  //   // for (const [key, value] of Object.entries(form.controls)) {
  //   //   console.log(`${key} : ${value.value}`, form.valid);
  //   // }
  //   // console.log(this.hwmMemberShipFormData, form.controls);

  //   this.form = form;

  //   localStorage.setItem('HWMForm', JSON.stringify(form.value));
  //   form.value.preferred_communication1 = this.preferred1Checkbox;
  //   form.value.preferred_communication2 = this.preferred2Checkbox;
  //   form.value.area_of_interest1 = this.interest1Checkbox;
  //   form.value.area_of_interest2 = this.interest2Checkbox;
  //   // console.log(form.value, form.valid, form.value.area_of_interest1);
  //   let formData = new FormData();

  //   if (
  //     form.valid
  //     //  &&
  //     // this.logoState == true &&
  //     // this.profile1State == true &&
  //     // this.profile2State == true &&
  //     // this.gstState == true &&
  //     // this.caState == true &&
  //     // this.ecState == true &&
  //     // this.cteState == true &&
  //     // this.ctoState == true &&
  //     // this.hwmState == true &&
  //     // this.appState == true &&
  //     // this.underState == true
  //   ) {
  //     let selectedState: any = [];
  //     // if (form.valid) {
  //     this.confirmationService.confirm({
  //       message: 'Are you sure you want to proceed?',
  //       header: 'Confirmation',
  //       icon: 'pi pi-info-circle',
  //       accept: () => {
  //         this.otpForm.patchValue({
  //           email: this.loggedInUserEmail,
  //         });
  //         let emailObject = {
  //           email: this.otpForm.value.email,
  //         };
  //         if (this.memberStatus == 'In Progress' || this.memberStatus == 'Pending') {
  //           this.adminSubmit()
  //         } else {
  //           this.apiservice.generateOTP(emailObject).subscribe((res: any) => {
  //             this.messageService.add({
  //               severity: 'success',
  //               detail: res.message,
  //             });
  //           });
  //           if (this.localStorage.role == 'HWM Owner' || this.localStorage.role == 'HWM Contact Person') {
  //             this.approveModalState = true;
  //           } else if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
  //             this.approveMemberModalState = true;
  //           }
  //         }

  //       },
  //     });
  //   } else if (
  //     this.gstState == false ||
  //     this.caState == false ||
  //     this.ecState == false ||
  //     this.cteState == false ||
  //     this.ctoState == false ||
  //     this.hwmState == false ||
  //     this.appState == false ||
  //     this.underState == false
  //   ) {
  //     this.messageService.add({
  //       severity: 'error',
  //       detail: 'Document Size Should Not Larger Then 10MB',
  //     });
  //   } else if (
  //     this.logoState == false ||
  //     this.profile1State == false ||
  //     this.profile2State == false
  //   ) {
  //     this.messageService.add({
  //       severity: 'error',
  //       detail: 'Image Size Should Not Larger Then 2MB',
  //     });
  //   } else {
  //     this.messageService.add({
  //       severity: 'error',
  //       detail: 'Please Fill All the Details!',
  //     });
  //   }
  // }

  // onImageClick() {
  //   // console.log('hwgsrgfyvkysdvu,sengijewrbku,fw3vg e');

  //   this.modalStyle = 'flex';
  // }
  onImageClose() {
    this.modalStyle = 'none';
  }

  bloackAlphabet(event: any) {
    if (event.key == 'Tab') {
      return;
    }
    const keyCode = event.keyCode;
    if (
      [46, 8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+C
      (event.keyCode === 67 && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+V
      (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
      // Allow: Ctrl+X
      (event.keyCode === 88 && (event.ctrlKey || event.metaKey)) ||
      // Allow: home, end, left, right
      (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if (
      (event.shiftKey || event.keyCode < 48 || event.keyCode > 57) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }
  //to remove one row to product detail
  removeProductDetailRow(index?: any, string?: any) {
    if (string == 'product') {
      if (this.hwmMemberShipFormData.product_details?.length > 1) {
        this.hwmMemberShipFormData.product_details.splice(index, 1);
      }
    } else {
      if (this.hwmMemberShipFormData.waste_details?.length > 1) {
        this.hwmMemberShipFormData.waste_details.splice(index, 1);

        // Remove corresponding entries for dropdown state/options
        if (this.newScheduleList) {
          this.newScheduleList.splice(index, 1);
        }
        if (this.scheduleListProcess) {
          this.scheduleListProcess.splice(index, 1);
        }

        // Re-initialize dropdowns for all rows to ensure correct state
        this.hwmMemberShipFormData.waste_details.forEach((item, idx) => {
          this.getScheduleList({ value: item.schedule_no }, 'schNo', idx, true);
          if (item.schedule_no === 1 || item.schedule_no === '1') {
            this.getScheduleList({ value: item.waste_process_no }, 'process-no', idx, true);
            this.getScheduleList({ value: item.waste_sub_process_no }, 'process-no', idx, true);
          }
        });

        // Defensive: clear code field if value is not present in options
        this.hwmMemberShipFormData.waste_details.forEach((item, idx) => {
          const options = this.newScheduleList[idx]?.value || [];
          if (item.waste_sub_process_no && !options.some(opt => opt.sub_process_no == item.waste_sub_process_no)) {
            item.waste_sub_process_no = '';
          }
        });
      }
    }
  }

  removeDoc(i: number) {
    if (this.hwmMemberShipFormData.supprting_doc?.length > 1) {
      this.hwmMemberShipFormData.supprting_doc.splice(i, 1);
    }
  }

  onDocUppload(event: any, index: number) {
    let selectedFile = event.target.files[0];
    this.hwmMemberShipFormData.supprting_doc[index].document = selectedFile;
    this.supporting_doc=true
    console.log('====================================');
    console.log(this.hwmMemberShipFormData.supprting_doc);
    console.log('====================================');
  }

  //to add one row to product detail
  // product_details_boolean: boolean = false;
  logoBaseURL: string = environment.HWMImgs_url;
  nominee1ImageBaseURL: string = environment.nominee1Image;
  nominee2ImageBaseURL: string = environment.nominee2Image;
  gstCertificateBaseURL: string = environment.gstCertificateURL;
  caCertificateBaseURL: string = environment.caCertificateURL;
  //upload files as binary
  fileUpload(event: any, string: any) {
    // console.log(event);
    this.selectedFile = event.target.files[0];
    var reader: any = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    if (string == 'logo') {
      if (this.selectedFile.size <= 2300000) {
        reader.onload = (event: any) => {
          this.logo = event.target.result;
        };
        this.logoPreviewState = true;
        this.hwmDocuments.logo = this.selectedFile;
        this.logoState = true;
        this.logoName = this.selectedFile.name;
      } else if (this.selectedFile.size > 2300000) {
        this.logoState = false;
      }
    } else if (string == 'profile1') {
      if (this.selectedFile.size <= 2300000) {
        reader.onload = (event: any) => {
          this.photoURL1 = event.target.result;
        };
        this.photo1 = true;
        this.hwmDocuments.profile1 = this.selectedFile;
        this.profile1State = true;
        this.profile1Name = this.selectedFile.name;
      } else if (this.selectedFile.size > 2300000) {
        this.profile1State = false;
      }
    } else if (string == 'profile2') {
      if (this.selectedFile.size <= 2300000) {
        reader.onload = (event: any) => {
          this.photoURL2 = event.target.result;
          // console.log(this.photoURL2);
        };
        this.photo2 = true;
        this.hwmDocuments.profile2 = this.selectedFile;
        this.profile2State = true;
        this.profile2Name = this.selectedFile.name;
      } else if (this.selectedFile.size > 2300000) {
        this.profile2State = false;
      }
    } else if (string == 'gst_certificate') {
      this.gstDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.gstCertificateURL = base64String;
        };
        this.gstCertificateCheck = true;
        this.hwmDocuments.gst_certificate = this.selectedFile;
        this.gstState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.gstState = false;
      }
    } else if (string == 'ca_certificate') {
      this.caDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.caCertificateURL = base64String;
        };
        this.caCertificateCheck = true;
        this.hwmDocuments.ca_certificate = this.selectedFile;
        this.caState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.caState = false;
      }
    } else if (string == 'ec_document') {
      this.ecDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.ecCertificateURL = base64String;
        };
        this.hwmDocuments.ec_document = this.selectedFile;
        this.ecCheck1 = true;
        this.ecState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.ecState = false;
      }
    } else if (string == 'cte_document') {
      this.cteDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.cteCertificateURL = base64String;
        };
        this.ecCheck2 = true;
        this.hwmDocuments.cte_document = this.selectedFile;
        this.cteState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.cteState = false;
      }
    } else if (string == 'cto_document') {
      this.ctoDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.ctoCertificateURL = base64String;
        };
        this.ecCheck3 = true;
        this.hwmDocuments.cto_document = this.selectedFile;
        this.ctoState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.ctoState = false;
      }
    } else if (string == 'hwm_document') {
      this.hwmDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.hwmCertificateURL = base64String;
        };
        this.ecCheck4 = true;
        this.hwmDocuments.hwm_document = this.selectedFile;
        this.hwmState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.hwmState = false;
      }
    } else if (string == 'undertaking') {
      this.utDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.utCertificateURL = base64String;
        };
        this.underTakingCheck = true;
        this.underTakingChanged = true;
        this.hwmDocuments.undertaking = this.selectedFile;
        this.underState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.underState = false;
      }
    } else if (string == 'application') {
      this.appDocName = this.selectedFile.name;
      if (this.selectedFile.size <= 10000000) {
        reader.onloadend = (event: any) => {
          let base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

          this.appCertificateURL = base64String;
        };
        this.applicationChanged = true;
        this.appDocCheck = true;
        this.hwmDocuments.application = this.selectedFile;
        this.appState = true;
      } else if (this.selectedFile.size > 10000000) {
        this.appState = false;
      }
    }
    if (
      string == 'ec_document' ||
      string == 'cte_document' ||
      string == 'cto_document' ||
      string == 'hwm_document'
    ) {
      this.requiredAnyOneDoc = false;
    }
    // console.log(this.selectedFile);
  }

  onImageClick(url: any, itemType?: any, name?: string, type?: string) {
    console.log('url :- ', url);
    alert();

    if (itemType == 'image') {
      if (type == 'company') {
        this.imageData.imageType = 'company';
        this.imageData.logoBoolean = true;
        this.imageData.url = this.oldLogoState
          ? this.logoBaseURL + this.hwmMemberShipFormData.logo
          : url;
      } else if (type == 'nominee1') {
        this.imageData.imageType = 'nominee1';
        this.imageData.nominee1Boolean = true;
        this.imageData.url = this.oldNominee1State
          ? this.nominee1ImageBaseURL + this.hwmMemberShipFormData.profile1
          : url;
        // this.imageData.url = url;
      } else if (type == 'nominee2') {
        this.imageData.imageType = 'nominee2';
        this.imageData.nominee2Boolean = true;
        this.imageData.url = this.oldNominee2State
          ? this.nominee2ImageBaseURL + this.hwmMemberShipFormData.profile2
          : url;
        // this.imageData.url = url;
      }
      // console.log(this.imageData);
    } else if (itemType == 'pdf') {
      var blob = this.b64toBlob(url, 'application/pdf');
      let a = document.createElement('a');
      document.body.appendChild(a);
      var pdf_url = window.URL.createObjectURL(blob);

      var anchor = document.createElement('a');
      // anchor.download = pdf_url;
      anchor.href = pdf_url;
      anchor.target = '_blank';
      anchor.click();

      // a.href = pdf_url;
      // a.download = String(name);
      // a.click();
      // window.URL.revokeObjectURL(pdf_url);
      // a.remove();
    }
  }
previewLocalFile(file: File) {
  const fileURL = URL.createObjectURL(file);
  window.open(fileURL, '_blank');
}
  isFile(document: any): boolean {
  return document instanceof File;
}
  public b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  imageData: any = {};
  logo: string;
  photoURL1: any;
  photoURL2: any;
  gstCertificateURL: any;
  ecURL1: string = '';
  ecURL2: string = '';
  ecURL3: string = '';
  ecURL4: string = '';
  underTakingURL: string = '';
  appURL: string = '';
  gstDocName: string;
  caCertificateCheck: boolean = true;
  caCertificateURL: string;
  caDocName: string;
  ecDocName: string;
  ecCertificateURL: any;
  cteDocName: string;
  cteCertificateURL: any;
  ctoCertificateURL: any;
  ctoDocName: string;
  hwmCertificateURL: any;
  hwmDocName: string;
  utCertificateURL: any;
  appDocName: string;
  appCertificateURL: any;
  utDocName: string;

  // logoPreviewState: boolean = true;
  photo1: boolean = true;
  photo2: boolean = true;
  ecCheck1: boolean = true;
  ecCheck2: boolean = true;
  ecCheck3: boolean = true;
  ecCheck4: boolean = true;
  underTakingCheck: boolean = true;
  appDocCheck: boolean = true;
  gstCertificateCheck: boolean = true;
  oldLogoState: boolean = true;
  // hwmDocuments: any = {};
  // productDetails: any = [];
  // member_classification: any = {};
  // selectedFile: File;
  // turnoverData: any = {};
  // categoryData: any = {};
  oldGstState: boolean = true;
  oldCaState: boolean = true;

  logoPreview(string: any,index:any) {
    this.confirmationService.confirm({
      message: 'Are you sure to change image?',
      header: 'Confirmation',
      accept: () => {
          if (string === 'supporting_doc' && index !== undefined) {
        this.hwmMemberShipFormData.supprting_doc[index].document = '';
        this.hwmMemberShipFormData.supprting_doc[index].doc_url = '';
        this.hwmMemberShipFormData.supprting_doc[index].document_for = '';
      }
        if (string == 'company') {
          this.hwmMemberShipFormData.logo = '';
          this.logoPreviewState = false;
          this.oldLogoState = false;
          this.logo = '';
        } else if (string == 'photo1') {
          this.hwmMemberShipFormData.profile1 = '';
          this.photo1 = false;
          this.oldNominee1State = false;
          this.photoURL1 = '';
        } else if (string == 'photo2') {
          this.hwmMemberShipFormData.profile2 = '';
          this.photo2 = false;
          this.oldNominee2State = false;
          this.photoURL2 = '';
        } else if (string == 'gstCertificate') {
          this.hwmMemberShipFormData.gst_certificate = '';
          this.gstCertificateCheck = false;
          // this.gstState = false;
          this.oldGstState = false;
          this.gstCertificateURL = '';
        } else if (string == 'caCertificateCheck') {
          this.hwmMemberShipFormData.ca_certificate = '';
          this.caCertificateCheck = false;
          this.oldCaState = false;
          this.caCertificateURL = '';
        } else if (string == 'ec1') {
          this.hwmMemberShipFormData.ec_document = '';
          this.oldecState = false;
          this.ecCheck1 = false;
          this.ecURL1 = '';
          this.addValidators();
        } else if (string == 'ec2') {
          this.hwmMemberShipFormData.cte_document = '';
          this.ecCheck2 = false;
          this.oldec2State = false;
          this.ecURL2 = '';
          this.addValidators();
        } else if (string == 'ec3') {
          this.hwmMemberShipFormData.cto_document = '';
          this.ecCheck3 = false;
          this.oldec3State = false;
          this.ecURL3 = '';
          this.addValidators();
        } else if (string == 'ec4') {
          this.hwmMemberShipFormData.hwm_document = '';
          this.oldec4State = false;
          this.ecCheck4 = false;
          this.ecURL4 = '';
          this.addValidators();
        } else if (string == 'undertaking') {
          this.hwmMemberShipFormData.undertaking = '';
          this.underTakingCheck = false;
          this.oldUndertakingState = false;
          this.underTakingURL = '';
        } else if (string == 'application') {
          this.hwmMemberShipFormData.undertaking = '';
          this.appDocCheck = false;
          this.oldAppState = false;
          this.appURL = '';
        }
      },
    });
  }

  addValidators() {
    if (
      this.hwmMemberShipFormData.ec_document == '' &&
      this.hwmMemberShipFormData.cte_document == '' &&
      this.hwmMemberShipFormData.cto_document == '' &&
      this.hwmMemberShipFormData.hwm_document == ''
    ) {
      this.requiredAnyOneDoc = true;
    }
  }

  // payment process razorpay
  payment(value?: any, orderId?: string, amount?: number): void {
    // this.approveModalState = false;

    this.apiservice
      .updateMemberInfo(this.formData)
      .subscribe((response: any) => {
        // // console.log(res);
        // this.successMessage = {
        //   form: 'hwm-edit',
        //   message: 'Form Submited Successfully',
        // };
        // this.successState = true;
        this.paymentStatus = true;
        this.paymentResponse = {
          formState: true,
          merchantRequest: this.gatewayResponse,
        };
      });
    // let options = {
    //   key: environment.rezorpay_key,
    //   currency: 'INR',
    //   base_amount: this.amount,
    //   name: 'UCCI',
    //   // description: 'Web Development',
    //   image: environment.rezorpay_logo,
    //   order_id: this.orderId,
    //   handler: function (response: any) {
    //     var event = new CustomEvent('payment.success', {
    //       detail: response,
    //       bubbles: true,
    //       cancelable: true,
    //     });
    //     window.dispatchEvent(event);
    //   },
    //   prefill: {
    //     name: '',
    //     email: '',
    //     contact: '',
    //   },
    //   notes: {
    //     address: '',
    //   },
    //   theme: {
    //     color: '#0ec6c6',
    //   },
    // };
    // // // console.log(options);

    // var rzp1 = new Razorpay(options);
    // rzp1.open();

    // rzp1.on('payment.failed', (response: any) => {
    //   let statusDetail = {
    //     status: 'Payment Failed',
    //     payment_id: response.error.metadata.payment_id,
    //     razorpay_signature: '',
    //     description: response.error.description,
    //     payment_for: 'Member Edit',
    //     payment_for_id: this.hwmMemberList?.id
    //   };
    //   this.paymentservice.servicePayment(this.orderId, statusDetail);
    // });
  }
  @HostListener('window:payment.success', ['$event'])
  onPaymentSuccess(event: any): void {
    // // console.log(event);
    let statusDetail = {
      status: 'Payment Success',
      payment_id: event.detail.razorpay_payment_id,
      razorpay_signature: event.detail.razorpay_signature,
      description: 'Payment Success',
      payment_for: 'Member Edit',
      payment_for_id: this.hwmMemberList?.id,
    };
    this.paymentservice
      .servicePayment(this.orderId, statusDetail)
      .subscribe((res: any) => {
        // // console.log(res);
        if (res.code == 200) {
          this.messageService.add({
            severity: 'success',
            detail: res.message,
          });
          this.apiservice
            .updateMemberInfo(this.formData)
            .subscribe((response: any) => {
              // // console.log(res);
              this.successMessage = {
                form: 'hwm-edit',
                message: 'Form Submited Successfully',
              };
              this.successState = true;
            });
        }
      });
  }
  // get area of interest list api function
  getAreaofInterest() {
    this.interestMasterService.getInterestArea().subscribe((res: any) => {
      // console.log(res);
      this.interest = res.data;
    });
  }
  // get nature of business list
  getNatureofBusiness() {
    this.nobmaster.getNatureofBusinessList().subscribe((res: any) => {
      // console.log(res);
      this.natureofBusinessList = res.data;
    });
  }
  // got to top when form submitted
  goToTop() {
    this.scroller.scrollToAnchor('backToTop');
  }
  // get turnover value on selection
  getValue(event: any, value: string) {
    console.log(this.hwmMemberShipFormData.productionStarted, event?.target?.value, event?.value);
    if (event.value == 1 && value == 'certificate') {
      this.certificateRequired = !this.certificateRequired;
    } else {
      this.certificateRequired = false;
    } if (this.hwmMemberShipFormData.productionStarted == '1' && value == 'production') {
      this.showCommencementDate = true;
    } else if (this.hwmMemberShipFormData.productionStarted == '0') {
      this.showCommencementDate = false;
    }
  }
  getRODetails() {
    this.apiservice.getRODetails().subscribe((res: any) => {
      console.log(res);
      this.roDetails = res?.data;
    })
  }
  getScheduleData() {
    this.apiservice.getWasteSchedule().subscribe((res: any) => {
      this.wasteList = res?.data;
      console.log("this.wasteList", this.wasteList);

      this.wasteList?.forEach((list: any) => {
        if (list?.sub_process_no == null) {
          this.scheduleArray.push(list);
        }
      })
    })

  }
  newScheduleList: any = {};
  scheduleListProcess: any = {};
  getScheduleList(event: any, value: string, index: any, isInit: boolean = false) {
    console.log(event?.value, this.wasteList);
    if (value == 'schNo') {
      if (event?.value != '1') {
        this.scheduleListProcess[index] = { showCodeInput: true, showProcessInput: true };
        if (!isInit) {
          this.hwmMemberShipFormData.waste_details[index].waste_process_no = '';
          this.hwmMemberShipFormData.waste_details[index].waste_sub_process_no = '';
          this.hwmMemberShipFormData.waste_details[index].waste_type = '';
        }
      } else {
        this.scheduleListProcess[index] = { showCodeInput: false, showProcessInput: false };
      }

      console.log(this.scheduleListProcess);
      console.log(this.hwmMemberShipFormData.waste_details);
      
    }
    else if (value == 'process-no') {
      this.scheduleList = [];
      this.wasteList?.forEach((list: any) => {
        if (event?.value == list?.process_no && list?.parent_id) {
          this.scheduleList.push(list);
        }
      })
    }
    else if (value == 'code') {
      let value = this.newScheduleList[index]?.value.filter(res => res.sub_process_no == event?.value);
      console.log(value);
      this.hwmMemberShipFormData.waste_details[index].waste_type = value[0]?.process_waste_type;
    }
    this.newScheduleList[index] = { index: index, value: this.scheduleList };

    // this.hwmMemberShipFormData.waste_details[index].schedule_no = this.scheduleList[0]?.schedule_no;
    // console.log(this.scheduleList);
  }
  pendingMemberships: any = [];
  async getPendingMembership() {
    try {
      let member_id: any;
      if (localStorage.getItem('a')) {
        member_id = JSON.parse(localStorage.getItem('member_id'));
      }
  
      const renewalListResponse:any = await this.apiservice.getPendingRenewalList(member_id);
      console.log(renewalListResponse);
      this.pendingMemberships = renewalListResponse.data;
  
      if (this.pendingMemberships?.length > 0) {
        // this.showAccessAlert = true;
        this.isRenewed = true;
      } else {
        const revisionDataResponse:any = await this.apiservice.getRevisionData();
        if (revisionDataResponse?.data) {
          let data = revisionDataResponse.data[0];
          if (data?.status == 'Approved') {
            this.showAccessAlert = false;
          } else {
            // this.showAccessAlert = true;
            // this.isRevised = true;
          }
        } else {
          this.showAccessAlert = false;
        }
      }
    } catch (error) {
      console.error("Error occurred while fetching data:", error);
      this.showAccessAlert = false;
    }
  }
  routeToDashboard() {
    this.route.navigateByUrl('user-panel')
  }
  adminSubmit() {
    console.log("alled");
    
    this.formData = new FormData();
    let selectedState: any = [];
    selectedState.push(this.form?.value?.state);
    // console.log(this.form.value.state);

    let selectedState1: any = [];

    selectedState1.push(this.form?.value?.nominee1_state);
    // console.log(this.form?.value?.nominee1_state);

    let selectedState2: any = [];
    selectedState2.push(this.form?.value?.nominee2_state);
    // console.log(this.form?.value?.nominee2_state);

    let selectedState3: any = [];
    selectedState3.push(this.form?.value?.factory_state);

    let selectedState4: any = [];
    selectedState4.push(this.form?.value?.registered_state);

    let selectedFactoryDistrict: any = [];
    selectedFactoryDistrict.push(this.form?.value?.factory_district);

    let selectedRegionalOffice: any = [];
    selectedRegionalOffice.push(this.form?.value?.regional_office);


    let selectedRegisteredDistrict: any = [];
    selectedRegisteredDistrict.push(this.form?.value?.registered_district);
    let wasteDisposalDate = moment(
      this.hwmMemberShipFormData.hw_disposal_expected_date
    ).format('YYYY/MM/DD');
    this.hwmMemberShipFormData.hw_disposal_expected_date = wasteDisposalDate;

    let production_commencement_date = moment(
      this.hwmMemberShipFormData.production_commencement_date
    ).format('YYYY/MM/DD');
    this.hwmMemberShipFormData.production_commencement_date =
      production_commencement_date;
    let past_letter_date = moment(
      this.hwmMemberShipFormData.past_letter_date
    ).format('YYYY/MM/DD');
    this.hwmMemberShipFormData.past_letter_date =
      past_letter_date;
    // console.log(this.hwmMemberShipFormData);
    let data = this.hwmMemberShipFormData;
    // console.log(data);
    for (const [key, value] of Object.entries(this.hwmMemberShipFormData)) {
      // // console.log(key, value);
      if (!(key in this.hwmDocuments)) {
        // // console.log(key);
        if (
          key != 'waste_details' &&
          key != 'product_details' &&
          key != 'area_of_interest1' &&
          key != 'area_of_interest2' &&
          key != 'state' &&
          key != 'nominee1_state' &&
          key != 'nominee2_state' &&
           key != 'factory_state' &&
          key != 'ec_consents_status' &&
          key != 'ec_document' &&
          key != 'cte_document' &&
          key != 'cto_document' &&
          key != 'hwm_document' &&
          key != 'undertaking' &&
          key != 'application' &&
          key != 'logo' &&
          key != 'profile1' &&
          key != 'profile2' &&
          key != 'gst_certificate' &&
          key != 'ca_certificate' &&
          key != 'nominee1_aoi' &&
          key != 'nominee2_aoi' &&
          key != null &&
          key != '' &&
          key != undefined
        ) {
          this.formData.append(key, `${value}`);
        }
      }
    }
    let ec_consents_status: any = [];
    let object: any = {};
    if (this.oldecState == false) {
      object = {
        is_ec_obtained: this.hwmMemberShipFormData.is_ec_obtained,
        is_ec_applied: this.hwmMemberShipFormData.is_ec_applied,
        ec_hold_reason: this.hwmMemberShipFormData.ec_hold_reason,
        ec_document: this.hwmDocuments.ec_document.name,
      };
    } else {
      object = {
        is_ec_obtained: this.hwmMemberShipFormData.is_ec_obtained,
        is_ec_applied: this.hwmMemberShipFormData.is_ec_applied,
        ec_hold_reason: this.hwmMemberShipFormData.ec_hold_reason,
        ec_document: this.ec_document,
      };
    }

    let object1: any = {};
    if (this.oldec2State == false) {
      object1 = {
        is_cte_applied: this.hwmMemberShipFormData.is_cte_applied,
        is_cte_obtained: this.hwmMemberShipFormData.is_cte_obtained,
        cte_hold_reason: this.hwmMemberShipFormData.cte_hold_reason,
        cte_document: this.hwmDocuments.cte_document.name,
      };
    } else {
      object1 = {
        is_cte_applied: this.hwmMemberShipFormData.is_cte_applied,
        is_cte_obtained: this.hwmMemberShipFormData.is_cte_obtained,
        cte_hold_reason: this.hwmMemberShipFormData.cte_hold_reason,
        cte_document: this.cte_document,
      };
    }

    let object2 = {};
    if (this.oldec3State == false) {
      object2 = {
        is_cto_applied: this.hwmMemberShipFormData.is_cto_applied,
        is_cto_obtained: this.hwmMemberShipFormData.is_cto_obtained,
        cto_hold_reason: this.hwmMemberShipFormData.cto_hold_reason,
        cto_document: this.hwmDocuments.cto_document.name,
      };
    } else {
      object2 = {
        is_cto_applied: this.hwmMemberShipFormData.is_cto_applied,
        is_cto_obtained: this.hwmMemberShipFormData.is_cto_obtained,
        cto_hold_reason: this.hwmMemberShipFormData.cto_hold_reason,
        cto_document: this.cto_document,
      };
    }

    let object3 = {};
    if (this.oldec4State == false) {
      object3 = {
        is_hwm_auth_applied: this.hwmMemberShipFormData.is_hwm_auth_applied,
        is_hwm_auth_obtained: this.hwmMemberShipFormData.is_hwm_auth_obtained,
        hwm_hold_reason: this.hwmMemberShipFormData.hwm_hold_reason,
        hwm_document: this.hwmDocuments.hwm_document.name,
      };
    } else {
      object3 = {
        is_hwm_auth_applied: this.hwmMemberShipFormData.is_hwm_auth_applied,
        is_hwm_auth_obtained: this.hwmMemberShipFormData.is_hwm_auth_obtained,
        hwm_hold_reason: this.hwmMemberShipFormData.hwm_hold_reason,
        hwm_document: this.hwm_document,
      };
    }
    ec_consents_status.push(object);
    ec_consents_status.push(object1);
    ec_consents_status.push(object2);
    ec_consents_status.push(object3);
    this.formData.append('ec_consents_status', JSON.stringify(ec_consents_status ?? null));
    this.formData.append('waste_details', JSON.stringify(this.hwmMemberShipFormData.waste_details ?? null));
    this.formData.append('product_details', JSON.stringify(this.hwmMemberShipFormData.product_details ?? null));
    this.formData.append('nominee1_state', selectedState1[0]?.name ?? '');
    this.formData.append('registered_state', selectedState4[0]?.name ?? '');
    this.formData.append('registered_district', selectedRegisteredDistrict[0]?.regional_office_name ?? '');
    this.formData.append('factory_district', selectedFactoryDistrict[0]?.regional_office_name ?? '');
    this.formData.append('regional_office', selectedRegionalOffice[0]?.regional_office_name ?? '');
    this.formData.append('factory_state', selectedState3[0]?.name ?? ''); // Hardcoded value
    if (this.ecCheck1 === false) {
      this.formData.append('ec_document', this.hwmDocuments?.ec_document ?? null);
    }
    if (this.ecCheck2 === false) {
      this.formData.append('cte_document', this.hwmDocuments?.cte_document ?? null);
    }
    if (this.ecCheck3 === false) {
      this.formData.append('cto_document', this.hwmDocuments?.cto_document ?? null);
    }
    if (this.ecCheck4 === false) {
      this.formData.append('hwm_document', this.hwmDocuments?.hwm_document ?? null);
    }
    if (this.underTakingChanged) {
      this.formData.append('undertaking', this.hwmDocuments?.undertaking ?? null);
    }
    if (this.applicationChanged) {
      this.formData.append('application', this.hwmDocuments?.application ?? null);
    }
    if (this.oldLogoState === false) {
      this.formData.append('logo', this.hwmDocuments?.logo ?? null);
    }
    if (this.oldNominee1State === false) {
      this.formData.append('profile1', this.hwmDocuments?.profile1 ?? null);
    }
    if (this.oldNominee2State === false) {
      this.formData.append('profile2', this.hwmDocuments?.profile2 ?? null);
    }
    if (this.oldUndertakingState === false) {
      this.formData.append('gst_certificate', this.hwmDocuments?.gst_certificate ?? null);
    }
    if (this.oldAppState === false) {
      this.formData.append('ca_certificate', this.hwmDocuments?.ca_certificate ?? null);
    }

    // if (!this.logoPreviewState) {
    //   this.formData.append('logo', this.hwmDocuments?.logo);
    // }

    // if (!this.nominee1PreviewState) {
    //   this.formData.append('profile1', this.hwmDocuments?.profile1);
    // }
    // if (!this.nominee2PreviewState) {
    //   this.formData.append('profile2', this.hwmDocuments?.profile2);
    // }
    // if (!this.gstDocState) {
    //   this.formData.append(
    //     'gst_certificate',
    //     this.hwmDocuments?.gst_certificate
    //   );
    // }
    // if (!this.caDocState) {
    //   this.formData.append('ca_certificate', this.hwmDocuments?.ca_certificate);
    // }
    // this.formData.append('preferred_communication1', this.preferred1Checkbox);
    for (var i = 0; i < this.preferred1Checkbox.length; i++) {
      // // console.log('hkdqVDWAE', this.preferred1Checkbox);
      this.formData.append(
        'preferred_communication1[]',
        this.preferred1Checkbox[i] ?? null
      );
    }
    let aoi1: any = [];
    for (
      var i = 0;
      i < this.hwmMemberShipFormData?.area_of_interest1?.length;
      i++
    ) {
      aoi1.push(this.hwmMemberShipFormData?.area_of_interest1[i].id);
    }

    console.log(this.hwmMemberShipFormData.area_of_interest1, "area_of_interest1");
    this.formData.append('nominee1_aoi', aoi1 ?? null);

    let aoi2: any = [];
    for (
      var i = 0;
      i < this.hwmMemberShipFormData?.area_of_interest2?.length;
      i++
    ) {
      aoi2.push(this.hwmMemberShipFormData?.area_of_interest2[i].id);
    }

    console.log("aoi1", aoi1);
    this.formData.append('nominee2_aoi', aoi2 ?? null);
    console.log( this.hwmMemberShipFormData.supprting_doc,"chekced");
if (this.supporting_doc) {
  this.hwmMemberShipFormData.supprting_doc.forEach((res: any, index: number) => {
    const isNewFile = res.document instanceof File;

    if (isNewFile) {
      this.formData.append(
        `supporting_doc[document][${index}]`,
        res.document
      );

      this.formData.append(
        `supporting_doc[document_for][${index}]`,
        res.document_for ?? ''
      );

      console.log('Uploading new file:', res);
    } else {
      // Skip existing files (strings/paths)
      console.log('Skipping existing file (path only):', res.document);
    }
  });
}

    this.newData = {
      company: {
        company_name: this.hwmMemberShipFormData?.company_name,
      },
      address: {
        factory_address: this.hwmMemberShipFormData?.factory_address,
        factory_city: this.hwmMemberShipFormData?.factory_city,
        factory_pin_code: this.hwmMemberShipFormData?.factory_pin_code,
        factory_state: selectedState3[0]?.name,
        factory_district: selectedFactoryDistrict[0]?.regional_office_name,
        // unit: this.hwmMemberShipFormData?.unit,
      },
      registeredAddress: {
        registered_address: this.RegisteraddressList[0]?.address,
        registered_state: selectedState4[0]?.name,
        registered_district: selectedRegisteredDistrict[0]?.regional_office_name,
        registered_city: this.RegisteraddressList[0]?.city,
        registered_pin_code: this.RegisteraddressList[0]?.pin_code,
      },

      // nominee1: {
      //   name1: this.hwmMemberShipFormData?.name1,
      //   designation1: this.hwmMemberShipFormData?.designation1,
      //   pan_number1: this.hwmMemberShipFormData?.pan_number1,
      //   email1: this.hwmMemberShipFormData?.email1,
      //   office_phone1: this.hwmMemberShipFormData?.office_phone1,
      //   mobile_no1: this.hwmMemberShipFormData?.mobile_no1,
      //   department1: this.hwmMemberShipFormData?.department1,
      //   profile1: this.hwmMemberShipFormData?.profile1,
      //   nominee1_address: this.hwmMemberShipFormData?.nominee1_address,
      //   nominee1_city: this.hwmMemberShipFormData?.nominee1_city,
      //   nominee1_pin_code: this.hwmMemberShipFormData?.nominee1_pin_code,
      //   biodata1: this.hwmMemberShipFormData?.biodata1,
      //   area_of_interest1: this.hwmMemberShipFormData?.area_of_interest1,
      //   preferred1: this.preferred1Checkbox,
      // },
      waste_details: this.hwmMemberShipFormData?.waste_details,
    };

    console.log(this.oldData, this.newData);

    // let oldCompanyData = JSON.stringify(this.oldData.company);
    // let newCompanyData = JSON.stringify(this.newData.company);
    // // let oldnominee1Data = JSON.stringify(this.oldData.nominee1);
    // // let newnominee1Data = JSON.stringify(this.newData.nominee1);
    // let oldAddressData = JSON.stringify(this.oldData.address);
    // let newAddressData = JSON.stringify(this.newData.address);
    // let oldRegisteredAddressData = JSON.stringify(this.oldData.registeredAddress);
    // let newRegisteredAddressData = JSON.stringify(this.newData.registeredAddress);
    // let oldWasteDetailData = JSON.stringify(this.oldData.waste_details);
    // let newWasteDetailData = JSON.stringify(this.newData.waste_details);
    // let changedItemes: any = [];

    // console.log(this.oldData, this.newData);
    // if (oldCompanyData != newCompanyData) {
    //   console.log('company array has same elements');

    //   changedItemes.push('company');
    // }
    // // if (oldnominee1Data != newnominee1Data) {
    // //   console.log('nominee1 array has same elements');
    // //   changedItemes.push('nominee1');
    // // }
    // if (oldRegisteredAddressData != newRegisteredAddressData) {
    //   console.log('nominee1 array has same elements');
    //   changedItemes.push('registeredAddress');
    // }
    // if (oldAddressData != newAddressData) {
    //   console.log('Address array has same elements');
    //   changedItemes.push('address');
    // }
    // if (oldWasteDetailData != newWasteDetailData) {
    //   console.log('Waste Details array has same elements');
    //   changedItemes.push('waste_detail');
    // }

    // this.formData.append('otp', this.otp);
    // this.formData.append('changed_in', changedItemes);
    // this.formData.append('membership_type', 'HWM');

    for (var i = 0; i < this.preferred2Checkbox.length; i++) {
      this.formData.append(
        'preferred_communication2[]',
        this.preferred2Checkbox[i] ?? null
      );
    }
    this.formData.append('user_id', this.userId ?? null);
    this.formData.append('member_id', this.memberId ?? null);
    this.apiservice
      .updateHwmMemberInfoByAdmin(this.formData, this.memberId)
      .subscribe((res: any) => {
        // console.log(res);
        this.messageService.add({
          severity: 'success',
          detail: res?.message,
        });
        this.successMessage = {
          form: 'hwm-edit',
          message: 'Form Submitted Successfully',
        };
        // this.successState = true;
        setTimeout(() => {
          this.route.navigateByUrl('/user-panel/member-data-update');
        });
      });

    // var orderIdObj: any = {
    //   changed_in: changedItemes,
    //   membership_type: 'HWM',
    //   member_id: this.memberId,
    // };
    // this.apiservice.getOrderId(orderIdObj).subscribe((res: any) => {
    //   console.log(res);
    //   if (this.localStorage.role != 'Admin' && this.localStorage.role != 'UCCI Staff') {
    //     this.approveModalState = false;
    //   } else if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
    //     this.approveMemberModalState = false;
    //   }
    //   this.spinner.hide();
    //   if (res?.gatewayResponse != '') {
    //     setTimeout(() => {
    //       this.orderId = res.data.order_id;
    //       this.formData.append('payment_id', res?.payment_id ?? '');
    //       this.amount = res.data.amount;
    //       this.gatewayResponse = res.gatewayResponse;
    //       this.formData.append('order_id', this.orderId);
    //       console.log(this.amount, this.orderId);
    //       if (this.localStorage.role == 'HWM Owner' || this.localStorage.role == 'HWM Contact Person') {
    //         this.payment();
    //       } else if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
    //         this.formData.append('order_id', this.orderId);
    //         this.formData.append('user_id', this.userId);
    //         this.formData.append('member_id', this.memberId);
    //       }
    //     }, 1500);
    //   } else if (res?.gatewayResponse == '') {
    //     if (this.localStorage.role == 'Admin' || this.localStorage.role == 'UCCI Staff') {
    //       this.formData.append('user_id', this.userId);
    //       this.formData.append('member_id', this.memberId);
    //     } else if (this.localStorage.role == 'HWM Owner' || this.localStorage.role == 'HWM Contact Person') {
    //       this.formData.append('order_id', '');
    //       this.formData.append('payment_id', res?.payment_id ?? '');
    //     }
    //     this.apiservice
    //       .updateMemberInfo(this.formData)
    //       .subscribe((res: any) => {
    //         // console.log(res);
    //         this.messageService.add({
    //           severity: 'success',
    //           detail: res?.message,
    //         });
    //         this.successMessage = {
    //           form: 'hwm-edit',
    //           message: 'Form Submitted Successfully',
    //         };
    //         this.successState = true;
    //         // setTimeout(() => {
    //         //   this.router.navigateByUrl('/');
    //         // }, 1500);
    //       });
    //   }
    // });
  }

}
